import { render, staticRenderFns } from "./tiki.vue?vue&type=template&id=5b7d23c0&scoped=true"
import script from "./tiki.vue?vue&type=script&lang=js"
export * from "./tiki.vue?vue&type=script&lang=js"
import style0 from "./tiki.vue?vue&type=style&index=0&id=5b7d23c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7d23c0",
  null
  
)

export default component.exports